import { render } from "./LoaderSpinnerLocal.vue?vue&type=template&id=77bc2f92&scoped=true"
import script from "./LoaderSpinnerLocal.vue?vue&type=script&lang=js"
export * from "./LoaderSpinnerLocal.vue?vue&type=script&lang=js"

import "./LoaderSpinnerLocal.vue?vue&type=style&index=0&id=77bc2f92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bc2f92"]])

export default __exports__